$.fn.triggerMultiple = function (list) {
  return this.each(function () {
    let $this = $(this);
    $.each(list.split(' '), function (k, v) {
      $this.trigger(v);
    });
  });
};


// WEBPACK FOOTER //
// ./app/webpacker/src/js/jQuery_prototype.js